// extracted by mini-css-extract-plugin
export default {"textBullet":"BulletNumber_textBullet__Fmikp","textNumber":"BulletNumber_textNumber__FJ2kw","containerContent":"BulletNumber_containerContent__XLXxg"};